import TrackingProvider from './TrackingProvider';

class FacebookPixel extends TrackingProvider {
    public initialize(trackingIds: string) {
        const ids = this.extractCleanTrackingIds(trackingIds);
        const debug = this.debug.bind(this);

        if (!this.isActive && ids.length > 0) {
            this._trackingIds = ids;

            /* eslint-disable */
            /* @ts-ignore */
            !(function (f, n) {
                if (typeof f.fbq === 'function') return;
                n = f.fbq = function () {
                    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
                    debug('fbq:', ...arguments);
                };
                /* @ts-ignore */
                if (!f._fbq) f._fbq = n;
                n.push = n;
                n.loaded = !0;
                n.version = '2.0';
                n.queue = [];
            })(window);
            /* eslint-enable */
            this.loadScript('https://connect.facebook.net/en_US/fbevents.js');
            this._active = true;

            this.trackingIds.forEach((id) => this.fbq('init', id));
            this.fbq('track', 'PageView');
        }

        return this;
    }

    public fbq(...args: any[]) {
        if (this.isActive) {
            window.fbq(...args);
        }
    }
}

export default new FacebookPixel().initialize(process.env.MIX_FACEBOOK_PIXEL_ID);
